import { getConfig } from '@cian/config/browser';

export function fetchTeaser(body: object) {
  const soprApi = getConfig().get<string>('soprApi');

  fetch(`${soprApi}teaser/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
}
